import * as React from "react";
import { forwardRef } from "react";
const SvgCaretDown = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" ref={ref} {...props}><path fill="currentColor" d="M8.701 9.73c-.368.36-1.034.36-1.402 0L3.112 5.639C2.855 5.388 3.068 5 3.462 5h9.075c.395 0 .608.388.35.639l-4.186 4.09z" /></svg>;
const ForwardRef = forwardRef(SvgCaretDown);
export default ForwardRef;